export const paymentTutorials = [
    {
      id: "QRIS",
      title: "Pembayaran Tagihan Goodnet melalui QRIS",
      logo: "https://vectorseek.com/wp-content/uploads/2023/09/Quick-Response-Code-Indonesia-Standard-QRIS-Logo-Vector.svg-.png",
      steps: [
        'Masuk ke Portal tagihan melalui Link billing Anda',
        "Buka aplikasi E-Banking atau E-Wallet anda",
        "Pilih metode pembayaran QRIS pada Portal anda",
        "Klik Bayar Dengan QRIS kemudian scan QR atau download QR",
        "Klik Scan Qris pada aplikasi E-Banking/E-wallet anda",
        "Scan Qris / Upload QR code anda",
        "Masukkan nominal sesuai tagihan",
        "Pilih 'Transfer'",
        "Konfirmasi rincian dan pilih 'Konfirmasi'",
        "Pembayaran Anda Telah Berhasil",
        "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
      ]
    },
  //   {
  //   id: "bni-mobile-transfer",
  //   title: "Pembayaran Tagihan Goodnet melalui Mobile Banking BNI",
  //   logo: "https://d2v6npc8wmnkqk.cloudfront.net/storage/6613/conversions/BNI-small.webp",
  //   steps: [
  //       'Masuk ke Portal tagihan melalui Link billing Anda',
  //       "Salin kode VA yang di pilih dari Portal Anda",
  //       "Akses BNI Mobile Banking kemudian masukkan user ID dan password",
  //       "Pilih menu Transfer",
  //       "Pilih menu Virtual Account Billing, lalu pilih rekening debet",
  //       "Masukkan nomor Virtual Account Anda (Contoh: 9881231000900025) pada menu Input Baru",
  //       "Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi",
  //       "Konfirmasi transaksi dan masukkan Password Transaksi",
  //       "Pembayaran Anda Telah Berhasil",
  //       "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
  //   ]
  // },
  {
    id: "bank-bca",
    title: "Pembayaran Tagihan Goodnet Melalui Bank BCA",
    logo: "https://www.bca.co.id/-/media/Feature/Header/Header-Logo/logo-bca.svg?v=1",
    steps: [
      'Masuk ke Portal tagihan melalui Link billing Anda',
      'Buka Daftar Transfer pada menu Transaksi > Transfer',
      "Pilih menu 'Transfer antar bank' atau 'Transfer online antarbank'",
      "Salin kode VA yang di pilih dari Portal Anda",
      "Masukkan 16 digit Nomor Virtual Account",
      'Setelah VA di masukkan, kembali kemudian masuk ke menu Transaksi > Transfer',
      'Pilih Transfer > Transfer Antar Bank',
      'Kemudian pilih Bank BNI, Masukkan VA dari daftar transfer',
      "Masukkan nominal sesuai tagihan",
      "Pilih Layanan Realtime-Transfer",
      "Konfirmasi rincian dan lanjutkan transaksi",
      "Pembayaran Anda Telah Berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "bank-bri",
    title: "Pembayaran Tagihan Goodnet Melalui Bank BRI",
    logo: "https://www.ir-bri.com/bbri_assets/vendor/img/bri-logo.png",
    steps: [
      'Masuk ke Portal tagihan melalui Link billing Anda',
      "Pilih menu 'Transfer antar bank' atau 'Transfer online antarbank'",
      "Salin kode VA yang di pilih dari Portal Anda",
      "Masukkan 16 digit Nomor Virtual Account",
      "Masukkan nominal sesuai tagihan",
      "Pilih Layanan Realtime-Transfer",
      "Konfirmasi rincian dan lanjutkan transaksi",
      "Pembayaran Anda Telah Berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "bank-mandiri",
    title: "Pembayaran Tagihan Goodnet Melalui Bank Mandiri",
    logo: "https://www.bankmandiri.co.id/image/layout_set_logo?img_id=31567&t=1757693631430",
    steps: [
      'Masuk ke Portal tagihan melalui Link billing Anda',
      "Pilih menu 'Transfer antar bank' atau 'Transfer online antarbank'",
      "Salin kode VA yang di pilih dari Portal Anda",
      "Masukkan 16 digit Nomor Virtual Account",
      "Masukkan nominal sesuai tagihan",
      "Pilih Layanan Realtime-Transfer",
      "Konfirmasi rincian dan lanjutkan transaksi",
      "Pembayaran Anda Telah Berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "alfamart",
    title: "Pembayaran via Alfamart, Alfamidi & Dan lainnya",
    logo: "https://d2v6npc8wmnkqk.cloudfront.net/storage/346/conversions/Alfamart-small.webp",
    steps: [
      'Masuk ke Portal tagihan melalui Link billing Anda',
      'Pilih Transaksi QRIS',
      "Informasikan ke kasir untuk pembayaran Goodnet melalui Qris",
      'Berikan QRIS anda ke kasir untuk di scan',
      "Kasir konfirmasi Nama Tujuan, nilai tagihan",
      "Lakukan pembayaran sesuai nominal",
      "Pembayaran Anda Telah berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "indomaret",
    title: "Pembayaran via Indomaret",
    logo: "https://d2v6npc8wmnkqk.cloudfront.net/storage/576/conversions/Indomaret-small.webp",
    steps: [
      'Masuk ke Portal tagihan melalui Link billing Anda',
      'Pilih Transaksi QRIS',
      "Informasikan ke kasir untuk pembayaran Goodnet melalui Qris",
      'Berikan QRIS anda ke kasir untuk di scan',
      "Kasir konfirmasi Nama Tujuan, nilai tagihan",
      "Lakukan pembayaran sesuai nominal",
      "Pembayaran Anda Telah berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "gopay",
    title: "Pembayaran Tagihan Goodnet dari Gopay, OVO atau E-wallet lainnya",
    logo: "https://gopay.co.id/_ipx/f_webp&w_175&q_70/assets/img/logo/gopay.webp",
    steps: [
        'Masuk ke Portal tagihan melalui Link billing Anda',
        "Buka aplikasi Gopay",
        "Pilih metode pembayaran QRIS pada Portal anda",
        "Klik Bayar Dengan QRIS kemudian scan QR atau download QR",
        "Klik Scan Qris pada aplikasi E-Banking/E-wallet anda",
        "Scan Qris / Upload QR code anda",
        "Masukkan nominal sesuai tagihan",
        "Pilih 'Transfer'",
        "Konfirmasi rincian dan pilih 'Konfirmasi'",
        "Pembayaran Anda Telah Berhasil",
        "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  {
    id: "bank-lain",
    title: "Pembayaran Tagihan Goodnet dari Bank Lainnya",
    logo: "https://upload.wikimedia.org/wikipedia/en/b/bb/ATM_Bersama.png?20131204161704",
    steps: [
      "Pilih menu 'Transfer antar bank' atau 'Transfer online antarbank'",
      "Salin kode VA yang di pilih dari Portal Anda",
      "Masukkan 16 digit Nomor Virtual Account",
      "Masukkan nominal sesuai tagihan",
      "Pilih Layanan Realtime-Transfer",
      "Konfirmasi rincian dan lanjutkan transaksi",
      "Pembayaran Anda Telah Berhasil",
      "Sistem memproses pembayaran secara realtime, Notifikasi Pembayaran akan di kirimkan melalui WhatsApp dan Email."
    ]
  },
  ];